import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader } from '../utils/loader/Loader';
import './projectarea.scss';

type props = {}

export const ProjectArea = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);

    useEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {
        
        return <Loader />;
    }
    else
        return <div className="project_area">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="project_info text-center">
                            <h3>Hai bisogno di assistenza?</h3>
                            <p>Compila il nostro form per ricevere assistenza. <br />
                        Vai alla pagina dei Contatti.</p>
                            <Link  onClick={() => {

                                props.clickhandler("contacts")
                            }
                            } to={'/Contacts'} className="boxed-btn3-white"> CONTATTACI </Link>
                            {/* <a href= "/#" className="boxed-btn3-white">Contact Us</a> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
}